module.exports = __webpack_public_path__ + "static/img/14.38ece211.png";